import React, { useEffect, useRef, useState } from 'react'
import Reviews from "./components/Reviews/Reviews";
import { useDispatch, useSelector } from "react-redux";
import debounce from "../../../../tools/debounce";
import transactionsActions from "../../../../store/analyticsStores/businessReportStore/businessReportActions";
import businessReportTypes from "../../../../store/analyticsStores/businessReportStore/businessReportTypes";
import { useCurrentBranch } from "../../../../hooks/useCurrentBranch";
import branchApi from "../../../../store/branchStore/branchApi";
import {Roles} from "../../../../config";

export default function ReviewsContainer() {
    const {info} = useSelector(state => state.branchReducer)
    // Set default start date to beginning of current year
    const getStartOfYear = () => {
        const now = new Date()
        return new Date(now.getFullYear(), 0, 1).getTime()
    }
    const [startDate, setStartDate] = useState(getStartOfYear())
    const [endDate, setEndDate] = useState(Date.now())
    const invisParams = useSelector(state => state.filtersReducer)
    const { currentRole } = useCurrentBranch()
    const [reviews, setReviews] = useState(null)

    const getReviews = (info, params, currentRole) => {
        if (currentRole === Roles.ADMINISTRATOR) {
            return branchApi.getReviews(info && info.group_id, params, currentRole)
        } else {
            return branchApi.getReviews(info && info.id, params, currentRole)
        }
    }

    useEffect(() => {
        if (info) {
            try {
                getReviews(
                  info,
                  { start_date: new Date(startDate).getTime(), end_date: new Date(endDate).getTime() },
                  currentRole
                )
                  .then((res) => {
                    console.log('Reviews API full response:', res)
                    setReviews(res?.data || null)
                  })
                  .catch((error) => {
                    console.error('Reviews API error:', error)
                    setReviews(null)
                  })
            } catch (error) {
                console.error('Reviews useEffect error:', error)
                setReviews(null)
            }
        }
    }, [info, endDate, startDate, currentRole])

    return (
        <Reviews
          reviews={reviews}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          invisParams={invisParams}
        />
    )
}
